export default __webpack_public_path__ + "static/media/ratchetwrench.9b1d164c.svg";